import { Grid, GridItem } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface SongDetailsFormGridProps {
  altTitle: ReactNode;
  notes: ReactNode;
  artist: ReactNode;
  genres: ReactNode;
  keySignature: ReactNode;
  timeSignature: ReactNode;
  tempo: ReactNode;
  language: ReactNode;
  explicit: ReactNode;
  duration: ReactNode;
  creationDate: ReactNode;
  location: ReactNode;
}

export const SongDetailsFormGrid = ({
  altTitle,
  notes,
  artist,
  genres,
  keySignature,
  timeSignature,
  tempo,
  language,
  explicit,
  duration,
  creationDate,
  location,
}: SongDetailsFormGridProps) => {
  return (
    <Grid
      templateRows="auto auto auto 1fr auto 1fr auto"
      templateColumns="repeat(4, 1fr)"
      columnGap={4}
      w="full"
    >
      <GridItem rowSpan={1} colSpan={1}>
        {altTitle}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {artist}
      </GridItem>
      <GridItem rowSpan={7} colSpan={2} mb={5}>
        {notes}
      </GridItem>
      <GridItem rowSpan={1} colSpan={2}>
        {genres}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {keySignature}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {timeSignature}
      </GridItem>
      <GridItem rowSpan={1} colSpan={2}>
        {tempo}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {language}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {explicit}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {duration}
      </GridItem>
      <GridItem rowSpan={1} colSpan={1}>
        {creationDate}
      </GridItem>
      <GridItem rowSpan={1} colSpan={2}>
        {location}
      </GridItem>
    </Grid>
  );
};
